import { ConfigObservable } from 'bz-stores/lib/config';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { StripeProvider } from 'react-stripe-elements';

import $ from 'jquery';
import featureFlag from 'tm3-core/stores/feature-store';

@observer
class StripeProviderWrapper extends React.Component {
  @observable hasStripeLoaded = false;
  isStripeLoading = false;
  constructor(props: any) {
    super(props);
    this.loadStripe();
  }

  @action.bound
  loadStripe() {
    this.isStripeLoading = true;
    $.getScript('https://js.stripe.com/v3/').then(() => {
      this.isStripeLoading = false;
      this.hasStripeLoaded = true;
    });
  }

  render() {
    if (!featureFlag.stripeEnabled) {
      return this.props.children;
    }
    const { stripeKey, apiKey } = this;
    return <StripeProvider stripe={stripeKey}>{this.props.children}</StripeProvider>;
  }

  @computed
  get apiKey() {
    const { config } = ConfigObservable;
    return !!config && config['TM3_PAYMENTS_STRIPE_PUBLIC_KEY'];
  }

  @computed
  get stripeKey() {
    const { apiKey, hasStripeLoaded } = this;
    let res = null;
    try {
      if (hasStripeLoaded && apiKey && window.Stripe) {
        res = window.Stripe(apiKey);
      }
    } finally {
      return res;
    }
  }
}

export default StripeProviderWrapper;
